import styled, { css, keyframes } from 'styled-components'

const shimmer = keyframes`
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
`

export const AIGlowText = styled.span<{ displayGlow?: boolean }>`
  ${props => props.displayGlow && css`
    display: block;
    background: linear-gradient(
      90deg,
      ${props.theme.palette.product.ai.dark} 0%,
      color-mix(in srgb, ${props.theme.palette.product.ai.dark} 70%, ${props.theme.palette.product.ai.light} 30%) 25%,
      ${props.theme.palette.product.ai.dark} 50%,
      color-mix(in srgb, ${props.theme.palette.product.ai.dark} 70%, ${props.theme.palette.product.ai.light} 30%) 75%,
      ${props.theme.palette.product.ai.dark} 100%
    );
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: ${shimmer} 3s linear infinite;
    font-weight: 600;
  `}
`

export default AIGlowText
